import { ChartResponse } from '../../redux/config/chart-data';
import { isEmptyValue } from '../../redux/config/details-window';
import { WidgetConfigurationData } from '../../redux/config/widgetApi';
import { IDataCommand } from '../data-transformer.interface';

export class HideBlankCategory
  implements IDataCommand<Array<ChartResponse>, WidgetConfigurationData, Array<ChartResponse>>
{
  process(data: Record<string, unknown>[]): ChartResponse[] {
    data?.forEach((item) => {
      Object.keys(item).forEach((k) => {
        if (isEmptyValue(k)) {
          delete item[k];
        }
      });
    });
    return data;
  }
}
